import{ useEffect, useState } from "react";

const FETCH_INTERVAL_MS = 15000; // 15s: istəsən artır/azalt
const PANIC_URL = "/panic.json"; // nginx/apache statik servis edə bilər

export default function MaintenanceGate({ children }) {
  const [state, setState] = useState({
    loading: true,
    panic: false,
    message: "",
  });

  async function load() {
    try {
      const res = await fetch(`${PANIC_URL}?_=${Date.now()}`, { cache: "no-store" });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const json = await res.json();
      setState({
        loading: false,
        panic: !!json.panic,
        message: json.message || "",
      });
    } catch (e) {
      // Əgər faylı tapa bilmirsə, default: açıq saxla
      setState(s => ({ ...s, loading: false, panic: false }));
    }
  }

  useEffect(() => {
    load();
    const t = setInterval(load, FETCH_INTERVAL_MS);
    return () => clearInterval(t);
  }, []);

  if (state.loading) {
    // minimal loading (istəsən skelet göstərə bilərsən)
    return null;
  }

  if (state.panic) {
    // Kilid ekranı — istəyə görə logo/telefon/mail əlavə et
    return (
      <div style={{
        minHeight: "100vh",
        display: "grid",
        placeItems: "center",
        background: "#0b1220",
        color: "#fff",
        padding: 24,
        textAlign: "center"
      }}>
        <div style={{ maxWidth: 640 }}>
          <h1 style={{ fontSize: 32, marginBottom: 8 }}>Sistem müvəqqəti bağlıdır</h1>
          <p style={{ opacity: 0.85 }}>
            {state.message || "Texniki işlər aparılır. Xahiş edirik sonra yenidən yoxlayın."}
          </p>
        </div>
      </div>
    );
  }

  return children;
}
